import InfiniteUnderline from '@@components/page/home/InfiniteUnderline';
import clx from '@@components/page/home/clx';
import { propertiesList } from '@@configs/properties';
import { useTranslations } from 'next-intl';

/**
 * Component: PropertiesSection
 */
const PropertiesSection = () => {
  const t = useTranslations();

  return (
    <section className={clx('properties-section')}>
      {propertiesList.map((text, i) => (
        <PropertyItem key={i} text={t(text)} />
      ))}
    </section>
  );
};
export default PropertiesSection;

/**
 * Component: PropertyItem
 */
const PropertyItem = ({ text }) => (
  <div className="flex max-w-sm flex-col place-items-start gap-2 text-center">
    <InfiniteUnderline />
    <p className="text-base leading-relaxed">{text}</p>
    {/* <div className={clx('underline', 'mt-auto')}></div> */}
  </div>
);
